import * as Yup from 'yup';

const getValidationSchemaStep3 = () => {
  const baseSchema = {
    DegreeId: Yup.string().required('DegreeId  is required'),
    // ShowOnAdmissionPage: Yup.boolean().required(
    //   "Required"
    // ),
    // AdmissionStart: Yup.date().required("AdmissionStart is required"),
    // AdmissionEnd: Yup.date().required("AdmissionEnd is required") .min(Yup.ref("AdmissionStart"), "End date must be after start date"),
    // AdmissionRequirementsEn: Yup.string().required(
    //   "Admission Requirements is required"
    // ),
    AdmissionRequirementsAr: Yup.string().required('مطلوب تعبئته'),
  };

  return Yup.object().shape(baseSchema);
};
export default getValidationSchemaStep3;
